import React from "react";

const alarmPriority = [
    { name: "High", value: 1 },
    { name: "Medium", value: 2 },
    { name: "Low", value: 3 },
];

const alarmType = [
    { key: 1, title: "Support Ticket Create" },
    { key: 2, title: "Support Ticket Update" },
    { key: 3, title: "Support Ticket Close" },
];

const alarmHistoryColumn = (hotels) => {
    const getPriority = (priority) => {
        const name = alarmPriority.find((e) => e.value == priority)?.name ?? "";
        return <span>{name}</span>;
    };

    const getAlarmType = (type) => {
        let name = "";
        const matched = alarmType.find((e) => e.key == type);
        if (matched) {
            name = matched.title;
        }

        return name;
    };

    return [
        {
            title: "Alarm Name",
            dataIndex: "alarm_name",
            key: "alarm_name",
            sorter: (a, b) => a.alarm_name.length - b.alarm_name.length,
        },
        {
            title: "Hotel Names",
            dataIndex: "alarm_hotel_ids",
            key: "alarm_hotel_ids",
            render: (record) =>
                record &&
                record.map((item) => {
                    const hotel_details = hotels.data.find(
                        (e) => e.hotel_id == item,
                    );
                    return (
                        <React.Fragment key={String(Math.random())}>
                            <span>{hotel_details?.hotel_name}</span>
                            <br />
                        </React.Fragment>
                    );
                }),
        },
        {
            title: "Emails",
            dataIndex: "alarm_email_ids",
            key: "alarm_email_ids",
            render: (record) =>
                record &&
                record.map((item) => {
                    return (
                        <React.Fragment key={String(Math.random())}>
                            <span>{item}</span>
                            <br />
                        </React.Fragment>
                    );
                }),
        },
        {
            title: "Phone Numbers",
            dataIndex: "alarm_phone_numbers",
            key: "alarm_phone_numbers",
            render: (record) =>
                record &&
                record.map((item) => {
                    return (
                        <React.Fragment key={String(Math.random())}>
                            <span>{item}</span>
                            <br />
                        </React.Fragment>
                    );
                }),
        },
        {
            title: "Priority",
            dataIndex: "priority",
            key: "priority",
            render: (record) => getPriority(record),
            sorter: (a, b) => a.priority - b.priority,
        },
        {
            title: "Alarm type",
            dataIndex: "alarm_type",
            key: "alarm_type",
            render: (record) =>
                record &&
                record.map((item) => {
                    return (
                        <React.Fragment key={String(Math.random())}>
                            <span>{getAlarmType(item)}</span>
                            <br />
                        </React.Fragment>
                    );
                }),
        },
        {
            title: "Created By",
            render: (text, record) => (
                <span>
                    {`${record.staff_first_name} ${record.staff_last_name}`}
                </span>
            ),
        },
    ];
};

export default alarmHistoryColumn;
